export class User {
    // primaryEmail: string;
    // secondaryEmail: string;
    loginID: string;
    email: string;
    password: string;
    role: string
    fname: string;
    mname: string;
    lname: string;
    pwd: string;
    conPwd: string;
    
}



// WEBPACK FOOTER //
// ./src/app/model/user.model.ts